import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SERVICES, formatPrice } from "@/lib/business";

const summary = (value) =>
  value.length === 0 ? "Leistungen wählen" : value.length === 1 ? value[0] : `${value.length} Leistungen gewählt`;

export const ServicePicker = ({ value, onChange, testId, dark = false }) => {
  const toggle = (name) =>
    onChange(value.includes(name) ? value.filter((v) => v !== name) : [...value, name]);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`mt-2 flex w-full items-center justify-between gap-3 border-b py-2 text-left text-base normal-case tracking-normal font-normal transition-colors ${
            dark ? "border-white/50 text-paper hover:border-white" : "border-ink/40 text-ink hover:border-plate"
          }`}
          data-testid={testId}
        >
          <span className="truncate">{summary(value)}</span>
          <ChevronDown size={16} className="shrink-0 opacity-70" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[var(--radix-popover-trigger-width)] min-w-[280px] rounded-none p-1 max-h-[60vh] overflow-y-auto" data-testid={`${testId}-list`}>
        {SERVICES.map((s, i) => {
          const on = value.includes(s.name);
          return (
            <button
              key={s.name}
              type="button"
              aria-pressed={on}
              onClick={() => toggle(s.name)}
              className={`flex w-full items-center gap-3 px-3 py-2.5 text-left text-sm transition-colors ${on ? "bg-plate/10" : "hover:bg-paper2"}`}
              data-testid={`${testId}-option-${i}`}
            >
              <span className={`flex h-4 w-4 shrink-0 items-center justify-center border ${on ? "border-plate bg-plate text-white" : "border-ink/40"}`}>
                {on && <Check size={12} strokeWidth={3} />}
              </span>
              <span className="flex-1 text-ink">{s.name}</span>
              <span className="tn text-xs text-inkmuted whitespace-nowrap">{formatPrice(s.price)}</span>
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
};
